import React from 'react';
import { Views } from 'react-big-calendar';
import { CalendarEventsPeriod } from '@trnsact/trnsact-shared-types';

import { CalendarMapper } from '../../mapper';
import { CalendarView, CalendarViewComponentProps } from '../../types';
import { TIME_GRID_ALL_DAY_MAX_ROWS } from '../../constants';
import { Calendar, CalendarConnector, CalendarEventCard } from '../calendar';

export const DayCalendar = ({ date, onNavigate, userProfileId }: CalendarViewComponentProps) => (
  <CalendarConnector
    userProfileId={userProfileId}
    period={CalendarEventsPeriod.Day}
    dateRange={CalendarMapper.getVisibleRange(CalendarView.Day, date)}
    children={props => (
      <Calendar
        step={10}
        timeslots={6}
        date={date}
        view={Views.DAY}
        views={[Views.DAY]}
        onNavigate={onNavigate}
        components={{
          event: props => <CalendarEventCard {...props} />,
        }}
        {...props}
        events={CalendarMapper.moveActivitiesToAllDayBand(props.events)}
        allDayMaxRows={TIME_GRID_ALL_DAY_MAX_ROWS}
      />
    )}
  />
);
